module.exports = __webpack_public_path__ + "img/cs-baseIt-1.06ec50df.jpg";